import classNames from 'classnames'

import { IconAlert, IconAlertCircle, IconCheckCircle, IconInfoCircle } from '@/components/Icons'

import Spinner from '../Spinner'

type Props = {
  type?: 'success' | 'error' | 'info' | 'warning' | 'naked'
  isList?: boolean
  alignIcon?: 'start' | 'center'
  loading?: boolean
  size?: 'sm' | 'base'
  className?: string
}
const MessageIcon: { [key: string]: React.ComponentType<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>> } = {
  SUCCESS: IconCheckCircle,
  ERROR: IconAlert,
  INFO: IconInfoCircle,
  WARNING: IconAlertCircle,
  NAKED: IconInfoCircle,
}

const Message: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  isList = false,
  alignIcon = 'center',
  type = 'success',
  loading,
  size = 'base',
  className,
}) => {
  const classes = {
    container: classNames(
      'rounded-lg px-5 py-3 bg-opacity-30 flex flex-col items-center justify-start space-y-3',
      {
        'bg-green-light text-green-dark': type === 'success',
        'bg-red-light text-red-dark': type === 'error',
        'bg-purple-extra-light text-purple-dark': type === 'info',
        'bg-yellow-light text-yellow-dark': type === 'warning',
        'bg-transparent border border-grey-light text-grey-base': type === 'naked',
        'text-sm': size === 'sm',
        'text-base': size === 'base',
      },
      className,
    ),
    icon: classNames('icon-sm'),
  }
  const Icon = MessageIcon[type.toUpperCase()]

  return (
    <div className={classes.container}>
      {isList ? (
        <div className="flex w-full items-center space-x-2">
          <Icon className={classes.icon} /> <div className="font-medium">Oops, something went wrong</div>
        </div>
      ) : null}
      <div
        className={classNames(
          'flex w-full justify-start space-x-2 text-left',
          alignIcon === 'center' ? 'items-center' : alignIcon === 'start' ? 'items-start' : '',
        )}
      >
        {!isList ? (
          <div>
            {loading ? (
              <Spinner size="sm" />
            ) : (
              <Icon className={classNames(classes.icon, alignIcon === 'start' ? 'mt-1.5' : '')} />
            )}
          </div>
        ) : null}{' '}
        <div className="flex-1 shrink">{children}</div>
      </div>
    </div>
  )
}

export default Message
